// MSAL Configuration for Azure AD authentication
const tenantId = process.env.REACT_APP_TENANT_ID;
const clientId = process.env.REACT_APP_CLIENT_ID;

export const msalConfig = {
  auth: {
    clientId: clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
    // Host only (per MSAL guidance). Tenant enforced by authority above.
    knownAuthorities: ['login.microsoftonline.com'],
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: { loggerCallback: (level, message) => console.log('[MSAL]', message) },
    allowNativeBroker: false
  }
};


// Login request configuration (basic OpenID scopes)
export const loginRequest = {
  scopes: ['openid', 'profile', 'offline_access'],
  prompt: 'select_account',
  authority: `https://login.microsoftonline.com/${tenantId}`,
};

// API request configuration
export const apiRequest = {
  scopes: [process.env.REACT_APP_API_SCOPE],
};

// Token request for API calls
export const tokenRequest = {
  scopes: [process.env.REACT_APP_API_SCOPE],
  forceRefresh: false,
};
